import { render, staticRenderFns } from "./project-lists.vue?vue&type=template&id=22b9a745&scoped=true&"
import script from "./project-lists.vue?vue&type=script&lang=js&"
export * from "./project-lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9a745",
  null
  
)

export default component.exports